import { createStore, applyMiddleware, combineReducers } from 'redux';
import { createLogger } from 'redux-logger';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';
import reducers from '../reducers';
import saga from '../sagas/saga';

// アプリケーションのレンダリング
const configureStore = (history) => {
  const sagaMiddleware = createSagaMiddleware();
  const middlewares = [routerMiddleware(history), sagaMiddleware];

  if (process.env.NODE_ENV !== 'production') {
    middlewares.push(createLogger());
  }
  const store = createStore(
    combineReducers({
      ...reducers,
      reducers,
      form: formReducer,
      router: routerReducer,
    }),
    composeWithDevTools(applyMiddleware(...middlewares)),
  );

  sagaMiddleware.run(saga);
  return store;
};

export default configureStore;
